<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import Button from '~/ui/Button.vue'
import Alert from '~/ui/Alert.vue'
import Spacer from '~/ui/Spacer.vue'

interface Events {
  (e: 'refresh'): void
}

interface Props {
  refresh?: boolean
}

const { t } = useI18n()

const emit = defineEmits<Events>()
withDefaults(defineProps<Props>(), {
  refresh: false
})
</script>

<template>
  <Alert class="color-blue-solid"
    style="align-items: center; grid-column: 1 / -1;"
  >
    <h4 class="ui header">
      <div class="content">
        <slot name="title">
          <Icon icon="bi:search" />
          {{ t('components.common.EmptyState.header.noResults') }}
        </slot>
      </div>
    </h4>
    <div class="inline center aligned text">
      <slot />
      <Spacer :size="16" />
      <Button
        v-if="refresh"
        class="color-primary-solid"
        @click="emit('refresh')"
      >
        {{ t('components.common.EmptyState.button.refresh') }}
      </Button>
    </div>
  </Alert>
</template>
